import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { LogIn, Building2, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AuthShell, AuthField, AuthError } from "@/components/AuthShell";

import { tr } from "@/lib/i18n";
export default function AuthPage() {
  const { user, login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ name: "", company: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const from = useLocation().state?.from || "/";
  if (user) return <Navigate to={from} replace />;
  const isLogin = mode === "login";
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      if (isLogin) await login(f.email, f.password); else await register(f);
      nav(from, { replace: true });
    } catch (ex) { setErr(apiError(ex)); } finally { setBusy(false); }
  };

  return (
    <AuthShell onSubmit={submit} title={isLogin ? tr("Accedi") : tr("Registra la tua azienda")}
      subtitle={isLogin ? tr("Inserisci le tue credenziali per aprire i progetti.") : tr("Diventerai l'amministratore dell'azienda e potrai invitare i tuoi colleghi via email. Se la tua azienda usa già Synvora Design, chiedi un invito al suo amministratore.")}>
      <div className="space-y-4">
        {!isLogin && <AuthField id="company" label={tr("Nome dell'azienda")} value={f.company} onChange={set("company")} required minLength={2} data-testid="auth-company-input" />}
        {!isLogin && <AuthField id="name" label={tr("Nome e cognome")} value={f.name} onChange={set("name")} required data-testid="auth-name-input" />}
        <AuthField id="email" label={tr("Email")} type="email" autoComplete="email" value={f.email} onChange={set("email")} required data-testid="auth-email-input" />
        <AuthField id="password" label={tr("Password")} type="password" autoComplete={isLogin ? "current-password" : "new-password"} minLength={isLogin ? undefined : 8}
          value={f.password} onChange={set("password")} required data-testid="auth-password-input" placeholder={isLogin ? "" : tr("Almeno 8 caratteri")} />
        {isLogin && <Link to="/password-dimenticata" className="block text-right text-sm text-[#0F52BA] hover:underline" data-testid="auth-forgot-link">{tr("Password dimenticata?")}</Link>}
      </div>
      <AuthError>{err}</AuthError>
      <Button type="submit" disabled={busy} className="w-full h-11 bg-[#0F52BA] hover:bg-[#0D47A1]" data-testid="auth-submit-btn">
        {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : isLogin ? <LogIn className="w-4 h-4 mr-2" /> : <Building2 className="w-4 h-4 mr-2" />}
        {isLogin ? tr("Accedi") : tr("Registra azienda")}
      </Button>
      <p className="text-sm text-slate-500 text-center">
        {isLogin ? tr("Nuova azienda?") : tr("Hai già un account?")}{" "}
        <button type="button" className="text-[#0F52BA] font-medium hover:underline" data-testid="auth-toggle-mode"
          onClick={() => { setMode(isLogin ? "register" : "login"); setErr(""); }}>{isLogin ? tr("Registra la tua azienda") : tr("Accedi")}</button>
      </p>
    </AuthShell>
  );
}
